import { render, staticRenderFns } from "./TcEventsList.vue?vue&type=template&id=7b836354&"
import script from "./TcEventsList.vue?vue&type=script&lang=js&"
export * from "./TcEventsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/inventia/Sites/coiico_totem/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b836354')) {
      api.createRecord('7b836354', component.options)
    } else {
      api.reload('7b836354', component.options)
    }
    module.hot.accept("./TcEventsList.vue?vue&type=template&id=7b836354&", function () {
      api.rerender('7b836354', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TcEventsList.vue"
export default component.exports